<template>
  <div class="sign-page">
    <div class="panel">
      <div class="row preview-full">
        <div id="BJCAPdfDiv" class="preview-container"></div>
      </div>
      <div v-if="errorMsg" class="error-container">
        <div class="error-icon">⚠️</div>
        <div class="error-content">
          <h4>PDF签章客户端连接失败</h4>
          <pre>{{ errorMsg }}</pre>
          <div class="error-actions">
            <el-button type="primary" size="small" @click="retryConnection">重试连接</el-button>
            <el-button type="default" size="small" @click="showHelp">查看帮助</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPdfBridgeData, clearPdfBridgeData, setPdfBridgeData } from '@/utils/pdfDataBridge'

// 常量配置
const PDF_CLIENT_PORT = 21051
const PDF_CLIENT_URL = `http://127.0.0.1:${PDF_CLIENT_PORT}/PDFClient/viewer.html`
const PDF_CLIENT_ORIGIN = `http://127.0.0.1:${PDF_CLIENT_PORT}`
const IFRAME_ID = 'BJCAPdfJsViewer'// iframe ID
const CONTAINER_ID = 'BJCAPdfDiv'// 容器ID
// 消息类型常量
const MESSAGE_TYPES = {
  INIT_SUCCESS: 'initSucceeded',// 初始化成功
  SIGN_PDF: 'signPdfBase64',// 签名PDF
  LOCAL_SIGN_SUCCESS: 'localSignSucceeded',// 本地签名成功
  FILE_LOAD_FAILED: 'fileLoadFailed',// 文件加载失败
  FILE_NOT_FOUND: 'fileNotFound',// 文件未找到
  ERROR: 'error',// 错误
  INIT_FAILED: 'initFailed'// 初始化失败
}
export default {
  name: 'PdfSignBridge',
  data() {
    return {
      // 配置参数
      sectionCode: '',// 标段编号
      saveType: 'path',// 保存类型
      savePath: 'C:\\BJCAROOT\\pawdocs\\PDFClient\\sign.pdf',
      returnPath: '',
      showPagingSealBtn: 1,// 是否显示分页印章按钮
      showSignContentBtn: 1,// 是否显示签名内容按钮
      showVerifyBtn: 1,// 是否显示验证按钮
      bSignConfirm: 1,// 是否需要确认签名
      showConfirmBtn: 1,// 是否显示确认按钮
      showRemoveBtn: 1,// 是否显示删除按钮
      showToolbar: true,// 是否显示工具栏
      token: Math.random(),// 令牌
      remotePdfUrl: '',// 远程PDF地址
      pdfBase64: '',// base64 PDF 内容（接口返回）
      pdfPosted: false,
      signedBase64: '',
      lastSavePath: '',
      pdfPageCount: 0,// PDF页码
      errorMsg: ''// 错误信息
    }
  },
  mounted() {
    window.addEventListener('message', this.handleMessage, false)
    window.addEventListener('resize', this.onWindowResize)
    this.initPage()
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage, false)
    window.removeEventListener('resize', this.onWindowResize)
  },
  methods: {
    // 初始化页面
    initPage() {
      const sectionCode = this.$route.query.sectionCode
      this.sectionCode = sectionCode
      this.saveType = this.$route.query.saveType || this.saveType
      this.savePath = this.$route.query.savePath || this.savePath
      this.returnPath = this.$route.query.returnPath || ''
      // 优先从 sessionStorage 读取缓存的 PDF base64
      const source = this.$route.query.source
      if (source === 'cache') {
        const cachedBase64 = getPdfBridgeData('pdfSignBase64')
        if (cachedBase64 && cachedBase64.trim()) {
          this.pdfBase64 = cachedBase64
          this.remotePdfUrl = ''
          this.loadPathSignData()
          clearPdfBridgeData('pdfSignBase64')
          this.initViewer()
          return
        }
      }
      this.loadPathSignData()
      this.initViewer()
    },
    loadPathSignData() {
      const memoryData = window.__caLocalSignPdfData
      const dataText = sessionStorage.getItem('caLocalSignPdfData')
      if (!memoryData && !dataText) {
        return
      }
      try {
        const data = memoryData || JSON.parse(dataText)
        this.pdfBase64 = data.fileBase64 || this.pdfBase64
        this.savePath = data.savePath || this.savePath
        this.returnPath = data.returnPath || this.returnPath
        this.saveType = data.saveType || this.saveType || 'path'
        if (data.remotePdfUrl) {
          this.remotePdfUrl = data.remotePdfUrl
        }
      } catch (error) {
        console.error('读取签章路径数据失败:', error)
      }
    },
    // 初始化PDF查看器
    async initViewer() {
      this.errorMsg = ''
      const dom = document.getElementById(CONTAINER_ID)
      if (!dom) return

      // 先检测PDF客户端是否可用
      const isClientAvailable = await this.checkPdfClient()
      if (!isClientAvailable) {
        this.errorMsg = `PDF签章客户端连接失败，请确认：
1. 已安装并启动PDF签章客户端
2. 客户端运行在端口 ${PDF_CLIENT_PORT}
3. 如使用HTTPS，请确保客户端支持HTTPS协议`
        return
      }

      const isDataMode = !!(this.pdfBase64 && this.pdfBase64.trim())
      const effectivePath = (this.remotePdfUrl && this.remotePdfUrl.trim())
      if (!isDataMode && !effectivePath) {
        this.errorMsg = '未找到可用的 PDF 地址'
        this.$message.warning('未找到可用的 PDF 地址')
        return
      }
      const queryParams = this.buildQueryParams(isDataMode ? '' : effectivePath)
      const src = `${PDF_CLIENT_URL}?${queryParams}`
      this.logInitInfo(isDataMode ? '[data-mode]' : effectivePath, src)
      dom.innerHTML = `<iframe src="${src}" id="${IFRAME_ID}" frameborder="0" scrolling="auto" width="100%" height="600"></iframe>`
      const ifm = document.getElementById(IFRAME_ID)
      this.changeFrameHeight(ifm)
    },
    // 构建查询参数
    buildQueryParams(filePathOrUrl) {
      const isDataMode = !!(this.pdfBase64 && this.pdfBase64.trim())
      const params = {
        openType: isDataMode ? 'data' : 'url',
        saveType: this.saveType || 'data',
        savePath: this.savePath,
        token: this.token || Math.random(),
        showPagingSealBtn: this.showPagingSealBtn ?? 1,
        showSignContentBtn: this.showSignContentBtn ?? 1,
        showVerifyBtn: this.showVerifyBtn ?? 1,
        bSignConfirm: this.bSignConfirm ?? 0,
        showConfirmBtn: this.showConfirmBtn ?? 0,
        showRemoveBtn: this.showRemoveBtn ?? 1,
        showToolbar: this.showToolbar ?? true
      }
      if (!isDataMode) {
        params.fileUrl = encodeURIComponent(filePathOrUrl)
      }
      return Object.entries(params)
        .map(([key, value]) => {
          const encodedValue = key === 'fileUrl' ? value : encodeURIComponent(value)
          return `${key}=${encodedValue}`
        })
        .join('&')
    },
    // 检测PDF客户端是否可用
    async checkPdfClient() {
      try {
        await fetch(PDF_CLIENT_ORIGIN, {
          method: 'GET',
          mode: 'no-cors',
          timeout: 3000
        })
        return true
      } catch (error) {
        console.error('PDF客户端连接检测失败:', error)
        return false
      }
    },
    // 重试连接
    retryConnection() {
      this.errorMsg = ''
      this.initViewer()
    },
    // 显示帮助信息
    showHelp() {
      this.$alert(`
PDF签章客户端连接问题解决方案：

1. 确认客户端已安装并启动
   - 检查系统托盘是否有PDF签章客户端图标
   - 如未启动，请手动启动客户端程序

2. 检查端口配置
   - 客户端应运行在 127.0.0.1:${PDF_CLIENT_PORT}

3. 防火墙设置
   - 确保防火墙允许客户端端口通信
   - 临时关闭防火墙测试连接

4. 协议匹配
   - 当前页面协议：${window.location.protocol}
   - 客户端地址：${PDF_CLIENT_ORIGIN}

5. 联系技术支持
   - 如问题持续，请联系PDF签章客户端技术支持
      `, 'PDF签章客户端帮助', {
        confirmButtonText: '确定',
        type: 'info'
      })
    },
    // 调整iframe高度（对齐参考demo逻辑）
    changeFrameHeight(ifm) {
      if (ifm != null && ifm !== undefined) {
        if (ifm.height !== '' && ifm.height != null && ifm.height !== undefined) {
          ifm.height = document.documentElement.clientHeight - 6
        }
      }
    },
    // 窗口resize事件处理
    onWindowResize() {
      const ifm = document.getElementById(IFRAME_ID)
      this.changeFrameHeight(ifm)
    },
    // 记录初始化信息
    logInitInfo(filePath, src) {
      console.log('文件路径:', filePath)
      console.log('pdf路径', src)
    },
    // 处理消息
    handleMessage(e) {
      const message = e.data
      if (!message || typeof message !== 'object') return
      // 打印所有收到的消息（调试用）
      console.log('[PDF客户端消息]', 'type:', message.type, 'data:', message)
      // 验证消息来源
      if (e.origin && e.origin !== PDF_CLIENT_ORIGIN && !e.origin.includes('127.0.0.1')) {
        console.warn('收到来自未知源的消息:', e.origin, message)
      }
      // 提取页码信息（可能在任何消息中携带）
      if (message.pageCount !== undefined || message.totalPages !== undefined || message.pageNum !== undefined) {
        this.pdfPageCount = message.pageCount || message.totalPages || message.pageNum || 0
        console.log('[PDF页码]', '总页数:', this.pdfPageCount)
      }
      const handlers = {
        [MESSAGE_TYPES.INIT_SUCCESS]: this.handleInitSuccess,
        [MESSAGE_TYPES.SIGN_PDF]: this.handleSignPdf,
        [MESSAGE_TYPES.LOCAL_SIGN_SUCCESS]: this.handleLocalSignSuccess,
        [MESSAGE_TYPES.FILE_LOAD_FAILED]: this.handleFileLoadError,
        [MESSAGE_TYPES.FILE_NOT_FOUND]: this.handleFileLoadError,
        [MESSAGE_TYPES.ERROR]: this.handleError,
        [MESSAGE_TYPES.INIT_FAILED]: this.handleError
      }

      const handler = handlers[message.type]
      if (handler) {
        handler.call(this, message)
      } else {
        console.log('收到其他消息类型:', message.type, message)
      }
    },
    // 处理初始化成功
    handleInitSuccess() {
      console.log('PDF 客户端初始化成功')
      this.errorMsg = ''
      // 如果是 base64 模式，在初始化完成后将 base64 传给客户端
      if (this.pdfBase64 && this.pdfBase64.trim()) {
        this.postPdfBase64()
      }
    },
    postPdfBase64() {
      if (this.pdfPosted || !this.pdfBase64) {
        return
      }
      try {
        const iframe = document.getElementById(IFRAME_ID)
        if (iframe && iframe.contentWindow) {
          iframe.contentWindow.postMessage({
            type: 'pdfBase64',
            contents: this.pdfBase64
          }, PDF_CLIENT_ORIGIN)
          this.pdfPosted = true
          console.log('已发送 pdfBase64 到 PDF 客户端')
        }
      } catch (e) {
        console.error('发送 base64 到 PDF 客户端失败', e)
      }
    },
    // 处理签后
    handleSignPdf(message) {
      const base64 = message.contents || message.pdfBase64 || message.signPdfBase64 || ''
      if (!base64) {
        console.error('未获取到签后 Base64')
      } else {
        this.signedBase64 = base64
        if (this.saveType === 'data') {
          this.submitSign(base64)
        }
      }
    },

    // 提交签名
    async submitSign(base64) {
      setPdfBridgeData('pdfSignedBase64', base64)
      setTimeout(() => {
        this.$router.go(-1)
      }, 1000)
    },
    // 处理本地签名成功
    handleLocalSignSuccess(message = {}) {
      this.lastSavePath = message.savePath || ''
      if (window.__caLocalSignPdfData) {
        window.__caLocalSignPdfData.signedBase64 = this.signedBase64
      } else {
        window.__caLocalSignPdfData = { signedBase64: this.signedBase64 }
      }
      sessionStorage.setItem('caLocalSignResult', JSON.stringify({
        savePath: this.savePath,
        actualSavePath: this.lastSavePath || '',
        hasSignedBase64: !!this.signedBase64
      }))
      this.$message.success('签章成功，即将返回')
      setTimeout(() => {
        if (this.returnPath) {
          this.$router.replace(this.returnPath)
        } else {
          this.$router.go(-1)
        }
      }, 800)
    },

    // 处理文件加载错误
    handleFileLoadError(message) {
      const errMsg = message.message || message.error || '文件加载失败，请检查文件路径是否正确'
      this.errorMsg = errMsg
      this.$message.error(`文件加载失败：${errMsg}`)
    },
    // 处理错误
    handleError(message) {
      const errMsg = message.message || message.error || '未知错误'
      this.errorMsg = errMsg
      console.error('PDF 客户端错误:', errMsg, message)
      this.$message.error(`PDF 客户端错误：${errMsg}`)
    },

  }
}
</script>

<style scoped>
.sign-page {
  padding: 0;
  height: 100vh;
}

.panel {
  margin: 0;
  padding: 0;
  max-width: 100%;
  height: 100vh;
  border: none;
  border-radius: 0;
  box-shadow: none;
  background: #fff;
}

.row {
  margin: 0;
}

.preview-full {
  height: 100vh;
}

.preview-container {
  height: 100%;
}

label {
  display: block;
  font-weight: 600;
  margin-bottom: 8px;
}

.tips {
  color: #909399;
  font-size: 12px;
  margin-top: 6px;
}

.error {
  margin-top: 12px;
  color: #f56c6c;
}

/* 错误提示样式 */
.error-container {
  display: flex;
  align-items: flex-start;
  padding: 20px;
  margin: 20px;
  background-color: #fff2f0;
  border: 1px solid #ffccc7;
  border-radius: 6px;
  color: #ff4d4f;
}

.error-icon {
  font-size: 24px;
  margin-right: 12px;
  flex-shrink: 0;
}

.error-content {
  flex: 1;
}

.error-content h4 {
  margin: 0 0 10px 0;
  font-size: 16px;
  font-weight: 600;
}

.error-content pre {
  margin: 10px 0;
  padding: 10px;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 12px;
  line-height: 1.4;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.error-actions {
  margin-top: 15px;
}

.error-actions .el-button {
  margin-right: 10px;
}
</style>